import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CognitoServiceService } from "src/app/services/auth/cognito-service.service";
import { UserPermissionsService } from "src/app/services/user-permissions.service";

@Injectable({
  providedIn: 'root'
})

export class AuthGuard {
  constructor(
    private authService: CognitoServiceService,
    private router: Router,
    private userPermissionsService: UserPermissionsService
  ){}

  async canActivate(): Promise<boolean> {
    try {
      // Verificar si tenemos un token y si es válido (refrescar si es necesario)
      const validToken = await this.authService.getValidToken();

      // Si no tenemos token válido después del intento de refresh, verificar OAuth
      if (!validToken) {
        console.warn('No se pudo obtener un token válido');

        // Verificar si hay código OAuth
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');

        if (code) {
          const authSuccess = await this.authService.processOAuthCallback(code);

          if (!authSuccess) {
            console.error('Autenticación fallida - logOut() se encargará de la redirección');
            return false;
          }

          return true;
        }

        // No hay token ni código OAuth, redirigir a login
        this.router.navigate(['/authentication/login']);
        return false;
      }

      const permissions = this.userPermissionsService.getPermissions();

      // Si no hay permisos cargados, cargarlos
      if (permissions.length === 0) {
        // Activar loading overlay mientras se cargan los permisos
        this.authService.setLoading(true);

        try {
          const loadedPermissions = await this.userPermissionsService.loadUserPermissions().toPromise();

          // Desactivar loading después de cargar
          this.authService.setLoading(false);

          // Verificar si el usuario no tiene accesos después de cargar
          if (!loadedPermissions || loadedPermissions.length === 0) {
            console.warn('Usuario sin permisos asignados, redirigiendo...');
            sessionStorage.setItem('logout_message', 'Usuario no autorizado. No tienes permisos asignados en el sistema.');
            this.authService.logOut();
            return false;
          }

        } catch (error: any) {
          console.error('Error cargando permisos:', {
            message: error?.message,
            status: error?.status,
            errorDetails: error
          });

          // Desactivar loading en caso de error
          this.authService.setLoading(false);

          // Verificar si es un error 401 o 403 (no autorizado)
          if (error?.status === 401 || error?.status === 403 || error?.message?.includes('401') || error?.message?.includes('403')) {
            console.warn('Error de autenticación, token posiblemente inválido');
            sessionStorage.setItem('logout_message', 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
          } else {
            sessionStorage.setItem('logout_message', `Error al verificar permisos. Por favor, intenta nuevamente.`);
          }

          this.authService.logOut();
          return false;
        }
      }

      return true;
    } catch (error) {
      console.error('Error inesperado en AuthGuard:', error);
      this.authService.setLoading(false);
      sessionStorage.setItem('logout_message', 'Error de autenticación. Por favor, intenta nuevamente.');
      this.authService.logOut();
      return false;
    }
  }
}
